interface translationObject {
	key: string;
	label: string;
	lang: types.redux.settings.language;
}

interface updateTranstalionAction extends types.redux.translations.updateTranstalionAction {}

export const transformUpdatedTranslations = (updatedTranslations: updateTranstalionAction) => {
	const translations = updatedTranslations.payload;
	let newTranslations: any = {};
	translations.forEach((obj: translationObject) => {
		newTranslations[obj.key] = {
			...newTranslations[obj.key],
			[obj.lang]: obj.label,
		};
	});
	return newTranslations;
};
